export default __webpack_public_path__ + "static/media/element_11.8f41468f.webp";